import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUser } from 'context/UserContext'
import { ButtonWrapper } from 'components/ButtonWrapper'
import { ChoiceButton } from 'components/ChoiceButton'
import { Heading } from 'components/Heading'

interface Props {
  nextRoute: string
}

export const MeditationEnergy: React.FC<Props> = ({ nextRoute }) => {
  const { t } = useTranslation('translation', {
    useSuspense: false,
  })

  const navigate = useNavigate()
  const { user } = useUser()
  const genderBasedBackground =
    user.gender === 'm'
      ? 'bg-meditation-energy-male bg-center'
      : 'bg-meditation-energy-female bg-center'

  const onButtonClick = () => {
    navigate(nextRoute)
  }

  return (
    <div className={`default-container flex flex-col ${genderBasedBackground}`}>
      <div className="flex h-full flex-col justify-between self-center overflow-auto px-7 pt-7 pb-10 lg:w-5/6 xl:w-5/12">
        <Heading text={t('meditation_pages.energy.title')} />

        <ButtonWrapper>
          <ChoiceButton
            onClick={onButtonClick}
            value={t('meditation_pages.energy.option_1')}
            id="option_1"
          />
          <ChoiceButton
            onClick={onButtonClick}
            value={t('meditation_pages.energy.option_2')}
            id="option_2"
          />
          <ChoiceButton
            onClick={onButtonClick}
            value={t('meditation_pages.energy.option_3')}
            id="option_3"
          />
          <ChoiceButton
            onClick={onButtonClick}
            value={t('meditation_pages.energy.option_4')}
            id="option_4"
          />
        </ButtonWrapper>
      </div>
    </div>
  )
}
